import { render, staticRenderFns } from "./homeDashboardGoalsStatisticsLazyRender.vue?vue&type=template&id=cbded622"
import script from "./homeDashboardGoalsStatisticsLazyRender.vue?vue&type=script&lang=js"
export * from "./homeDashboardGoalsStatisticsLazyRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports